import React, { useCallback, useState } from 'react'
import Breadcrumbs from '../../../components/Common/Breadcrumb'
import {
  Card,
  CardBody,
  Col,
  Row,
} from "reactstrap"
import { Table } from "react-bootstrap"
import { withTranslation } from "react-i18next"
import { ERROR_KEY } from '../../../Constants/MainKeys'
import { addRightSectionSpinner, removeRightSectionSpinner } from '../../../store/spinner/actions'
import AlertService from '../../../Services/alertService'
import { useDispatch, useSelector } from 'react-redux'
import HtmlHead from '../../../components/HtmlHead/HtmlHead'
import ReactPaginate from 'react-paginate'
import ApiService from '../../../Services/ApiService'
import uuid from 'react-uuid'
import { useEffect } from 'react'
import * as moment from 'moment'
import RightSectionSpinner from '../../../components/Spinners/RightSectionSpinner'
import NoData from '../../../components/NoData/NoData'
import MainService from '../../../Services/MainService'


const Customers = (props) => {

  const title = "Customers"
  const description = ""
  const pageSize = 20;
  const { t } = props;
  const dispatch = useDispatch();
  const { rightSectionSpinners } = useSelector(state => state.Spinners);
  const [customers, setCustomers] = useState([]);
  const [activePageNumber, setActivePageNumber] = useState(0);

  useEffect(() => {
    getCustomers();
  }, [])

  const getCustomers = () => {
    const spinnerId = uuid();
    setRightSectionSpinner(spinnerId);
    ApiService.getCustomers().then(response => {
      if (response && response.data) {
        const data = [...response.data];
        setCustomers(data);
      }
    }).catch(error => getFail(error)).finally(() => {
      extractRightSectionSpinner(spinnerId);
    })
  }

  const scrollTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  }

  const handlePageClick = (event) => {
    setActivePageNumber(event.selected);
    scrollTop();
  }

  const setRightSectionSpinner = useCallback(spinner => {
    dispatch(addRightSectionSpinner(spinner));
  }, []);

  const extractRightSectionSpinner = useCallback(spinner => {
    dispatch(removeRightSectionSpinner(spinner));
  }, []);

  const getFail = (error) => {
    error && AlertService.alert((AlertService.checkMessageType(error.respcode) || ERROR_KEY), error);
  }

  const startIndex = activePageNumber * pageSize;
  const endIndex = startIndex + pageSize;

  return (
    <>
      <HtmlHead title={title} description={description} />
      <div className='page-content position-relative min-h-100vh'>
        <RightSectionSpinner spinner={rightSectionSpinners} />
        <div className="container-fluid">
          <Breadcrumbs
            title="Cryllex"
            breadcrumbItem="Customers"
          />
          <Row>
            <Col lg={12}>
              <Card className='p-3'>
                <div>
                  <div className="table-responsiv">
                    {
                      customers && customers.length ?
                        <Table className="table table-striped mb-0">
                          <thead>
                            <tr className='cursor-default'>
                              <th>Name</th>
                              <th>Email</th>
                              <th>DOB</th>
                              <th>Country</th>
                              <th>City</th>
                              <th>Phone Number</th>
                              <th>Address</th>
                            </tr>
                          </thead>
                          <tbody>
                            {customers.slice(startIndex, endIndex).map((customer, index) => {
                              return <tr key={index} className='cursor-default'>
                                <th>
                                  <p className='word-break-break-word max-line-2 m-0' >{customer.firstname}</p>
                                  <p className='word-break-break-word max-line-2 m-0' >{customer.lastname}</p>
                                </th>
                                <td>
                                  <p className='word-break-break-word max-line-2 m-0' >{customer.email}</p>
                                </td>
                                <td>
                                  <p className='word-break-break-word max-line-2 m-0' >{moment(new Date(customer.dateOfBirth)).format("L")}</p>
                                </td>
                                <td>
                                  <p className='word-break-break-word max-line-2 m-0' >{customer.country}</p>
                                </td>
                                <td>
                                  <p className='word-break-break-word max-line-2 m-0' >{customer.city}</p>
                                </td>
                                <td>
                                  <p className='word-break-break-word max-line-2 m-0 text-nowrap' >{MainService.formatPhoneNumber(customer.phoneNumber)}</p>
                                </td>
                                <td>
                                  <p className='word-break-break-word max-line-2 m-0' >{customer.address}</p>
                                </td>
                              </tr>
                            })}
                          </tbody>
                        </Table>
                        : <NoData />
                    }
                  </div>

                </div>
                {
                  customers && customers.length ?
                    <div className='p-3 d-flex justify-content-end'>
                      <Row>
                        <Col>
                          <ReactPaginate
                            nextLabel="Next"
                            onPageChange={handlePageClick}
                            pageRangeDisplayed={3}
                            marginPagesDisplayed={2}
                            pageCount={Math.ceil(customers.length / pageSize)}
                            previousLabel="Previous"
                            pageClassName="page-item"
                            pageLinkClassName="page-link"
                            previousClassName="page-item"
                            previousLinkClassName="page-link"
                            nextClassName="page-item"
                            nextLinkClassName="page-link"
                            breakLabel="..."
                            breakClassName="page-item"
                            breakLinkClassName="page-link"
                            containerClassName="pagination"
                            activeClassName="active"
                            forcePage={activePageNumber}
                          />
                        </Col>
                      </Row>
                    </div>
                    : null
                }
              </Card>
            </Col>
          </Row>
        </div>
      </div>
    </>
  )
}

export default withTranslation()(Customers)